import "./LandingPage.scss";
import Header from "../Header/Header";
import LandingBody from "../LandingBody/LandingBody";
import Footer from "../Footer/Footer";

const LandingPage = () => {
  return (
    <div>
      <Header />
      <LandingBody />
      <Footer />
    </div>
  );
};

export default LandingPage;
